import { useState } from 'react';
import { Trans, useLingui } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import IconEdit from '@/icons/Edit.svg';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';

import { BaseMessage } from './BaseMessage';
import ManuallyUpdateStatusDueAtDialog from './ManuallyUpdateStatusDueAtDialog';

export const ExchangeArticleTaskMessage = () => {
  const { article, iam } = useArticleContext();
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useLingui();
  const { workflow } = useRequestContext();
  const exchangeStep = workflow?.nodes.find((node) => 'step' in node && node.step === 'exchange');
  const canEditStatusDueAt =
    article.step?.step === 'exchange' ? exchangeStep?.config?.editExchangeDueDays?.enabled : false;

  const EditButton = canEditStatusDueAt ? (
    <Button
      variant="secondary"
      size="small"
      iconOnly
      tooltip={t({
        id: 'article.step-task-message.exchange.edit',
        message: 'Edit exchange completion date',
      })}
      ariaLabel={t({
        id: 'article.step-task-message.exchange.edit',
        message: 'Edit exchange completion date',
      })}
      onPress={() => setIsOpen(true)}
    >
      <IconEdit />
    </Button>
  ) : undefined;

  return (
    <>
      <BaseMessage
        title={<Trans id="article.task.exchange-article.title">Confirm the exchange</Trans>}
        message={
          <p>
            {iam.hasUserScopeOnArticle('stockLocation') ? (
              <Trans id="article.task.exchange-article.message">
                Please confirm that you can proceed with the exchange.
              </Trans>
            ) : (
              <Trans id="article.task.exchange-article.on-behalf.message">
                Please contact the workshop to validate the exchange on its behalf.
              </Trans>
            )}
          </p>
        }
        article={article}
        titleAction={EditButton}
      />
      <ManuallyUpdateStatusDueAtDialog article={article} isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};
